import type { ReactNode } from "react";
import { Text } from "@nbs/ui";

export type NbsChartContainerProps = {
  readonly title: string;
  readonly description?: string;
  readonly unit?: string | null;
  readonly period?: string | null;
  readonly territory?: string | null;
  readonly source?: string | null;
  readonly updatedAt?: string | null;
  readonly isLoading?: boolean;
  readonly error?: string | null;
  readonly empty?: boolean;
  readonly emptyMessage?: string;
  readonly actions?: ReactNode;
  readonly children: ReactNode;
  readonly table?: ReactNode;
};

export function NbsChartContainer({
  title,
  description,
  unit,
  period,
  territory,
  updatedAt,
  isLoading,
  error,
  empty,
  emptyMessage = "Aucune mesure disponible pour cette période et ces filtres.",
  actions,
  children,
  table,
}: NbsChartContainerProps) {
  return (
    <section className="nbs-chart-container" aria-label={title}>
      <header className="nbs-chart-container__header">
        <div>
          <h3 className="nbs-chart-container__title">{title}</h3>
          {description ? (
            <Text tone="muted" className="nbs-chart-container__desc">
              {description}
            </Text>
          ) : null}
          <Text tone="muted" className="nbs-chart-container__meta">
            {[
              unit && `Unité : ${unit}`,
              period && `Période : ${period}`,
              territory && `Territoire : ${territory}`,
            ]
              .filter(Boolean)
              .join(" · ")}
          </Text>
        </div>
        {actions}
      </header>
      {isLoading ? (
        <div className="nbs-chart-container__skeleton" role="status">
          Chargement…
        </div>
      ) : error ? (
        <Text role="alert" className="nbs-text--error">
          {error}
        </Text>
      ) : empty ? (
        <div className="nbs-chart-container__empty">
          <Text>{emptyMessage}</Text>
        </div>
      ) : (
        <div className="nbs-chart-container__body">{children}</div>
      )}
      {table}
      {updatedAt ? (
        <footer className="nbs-chart-container__footer">
          <Text tone="muted">Mise à jour : {updatedAt}</Text>
        </footer>
      ) : null}
    </section>
  );
}
